import configs from '../configs'
import "block-ui"
import bootbox from 'bootbox'
import axios from 'axios'

export default {
    // timezone - fusos horários disponíveis no sistema
    getSystemTimezones() {
        return [
            { value: 'America/Araguaina', label: 'América - Araguaína' },
            { value: 'America/Bahia', label: 'América - Bahia' },
            { value: 'America/Belem', label: 'América - Belém' },
            { value: 'America/Boa_Vista', label: 'América - Boa Vista' },
            { value: 'America/Campo_Grande', label: 'América - Campo Grande' },
            { value: 'America/Cuiaba', label: 'América - Cuiabá' },
            { value: 'America/Fortaleza', label: 'América - Fortaleza' },
            { value: 'America/Noronha', label: 'América - Fernando de Noronha' },
            { value: 'America/Maceio', label: 'América - Maceió' },
            { value: 'America/Manaus', label: 'América - Manaus' },
            { value: 'America/Porto_Velho', label: 'América - Porto Velho' },
            { value: 'America/Recife', label: 'América - Recife' },
            { value: 'America/Rio_Branco', label: 'América - Rio Branco' },
            { value: 'America/Sao_Paulo', label: 'América - São Paulo' },
            { value: 'America/Santarem', label: 'América - Santarém' }
        ]
    },

    // Definir título da página TODO - melhorar metodologia posteriormente
    setPageTitle(desc) {
        window.document.title = configs.name + ' - ' + desc
    },

    /**
     * Format default url segment.
     *
     * @param segment
     *
     * @return string
     */
    url(segment = '')
    {
        return configs.url + segment
    },

    /**
     * Format default url API.
     *
     * @param segment
     *
     * @return {string}
     */
    urlAPI(segment = '')
    {
        return `${ configs.api + segment }`
    },

    /**
     * Método padrão para criação de requests a API principal.
     *
     * @param context
     * @param resource
     * @param data
     * @param method
     * @param contentType
     *
     * @returns {AxiosPromise<any>}
     */
    requestToAPI(context, resource, data, method = 'GET', contentType = 'application/json')
    {
        let tokenJWT = ( context.$store.getters.tokenJWT ? context.$store.getters.tokenJWT : '' )
        let axiosInstance = axios.create({
            baseURL: `${ configs.api }`,
            timeout: 120000,
            headers: ( {
                'Content-Type': contentType,
                'Tallos-Internal-Request': true,
                'access_token': process.env.VUE_APP_TOKEN_MEGASAC
            } )
        });

        switch (method) {
            case 'GET':
                return axiosInstance.get(resource, data)
            case 'POST':
                return axiosInstance.post(resource, data)
            case 'PUT':
                return axiosInstance.put(resource, data)
            default :
                return axiosInstance.get(resource, data)
        }
    },

    /**
     * Exibir nova View
     *
     * @param context
     * @param view
     *
     * @return void
     */
    showView(context, view)
    {
        // se próprio perfil do jogador deve ser exibido
        if (view.view !== undefined) {
            if (view.view === 'profile' && (parseInt(view.parameters.id) === context.user.id)) {
                this.showView(context, 'profile')
                return
            }
        }

        let views = context.$store.getters.view
        views.push(view)
        // definir view a ser exibida
        context.$store.dispatch('defineView', views)
    },

    /**
     * Verificar se integração do messenger esta inativa.
     *
     * @param company
     *
     * @return boolean
     */
    messengerOff(company) {
        return (!company.settings) || (!company.settings.facebook_active_pages) || ( company.settings.facebook_active_pages.length === 0 )
    },

    /**
     * Verificar se integrações do whatsapp estão ativas.
     *
     * @param company
     *
     * 1 - todos os whastsapp ativo [verde]
     * 2 - pelo menos 1 whatsapp ativo [cinza]
     * 3 - nenhum whatsapp ativo [vermelho]
     *
     * @return int
     *
     */
    whatsappOff(company) {
        let count = 0
        if (!company.whatsapps) { return 3; }
        let integration;
        for (let i in company.whatsapps) {
            integration = company.whatsapps[i];
            if ( integration.access_token && integration.session ) { count++; }
        }
        if ( count === Object.keys(company.whatsapps).length ) { return 1; }
        else if ( count > 0 ) { return 2; }
        return 3;
    },

    /**
     * Verificar se integrações do instagram estão ativas.
     *
     * @param company
     *
     * 1 - todos os instagrams ativo [verde]
     * 2 - pelo menos 1 instagram ativo [cinza]
     * 3 - nenhum instagram ativo [vermelho]
     *
     * @return int
     */
    instagramOff(company) {
        let count = 0;
        if (!company.instagrams) { return 3; }
        let integration;
        for (let i in company.instagrams) {
            integration = company.instagrams[i];
            if (integration.access_token) { count++; }
        }
        if ( count === Object.keys(company.instagrams).length ) { return 1; }
        else if ( count > 0 ) { return 2; }
        return 3;
    },

    /**
     * Verificar se a integração para gerenciamento de contatos do e-mail conectado ao dispositivo integrado ao Gerenciador de Contatos está ativa.
     *
     * @param company
     *
     * True - Integração Inativa [vermelho]
     * False - Integração Ativa [verde]
     *
     * @return bool
     */
    contactsManagerOff(company) {
        return !company.settings.contacts_manager_access_token || !company.settings.contacts_manager_ddd ;
    },

    /**
     * Exibir informações do endereço da Empresa contidas na sessão do usuário logado.
     *
     * @param company
     *
     * @return string
     */
    showCompanyAddress(company) {
        if (company.address.street && company.address.district && company.address.city &&
            company.address.state && company.address.country && company.address.number) {
            return company.address.street + ', ' + company.address.district + ', ' +
                company.address.city + ', ' + company.address.state + ', ' + company.address.country +
                ' - N° ' + company.address.number;
        }
        return 'Informações incompletas para o endereço...';
    },

    // home com frases motivacionais
    // fontes:
    // https://www.belasmensagens.com.br/frases-motivacionais
    // https://www.frasesparaface.com.br/frases-motivacionais/
    motivationalPhrases(n) {
        switch (n)
        {
            case 1:
                return (
                    'Você está evoluindo, acredite em si mesma. Apesar dos dias parecerem tempestades sem fim, você é forte. Você conseguirá.'
                );

            case 2:
                return (
                    'Encare a vida com o olhar de uma criança, com a sensibilidade de uma mulher e com a força de um guerreiro.'
                );

            case 3:
                return (
                    'Todos os seus sonhos podem se tornar realidade se você tem coragem para persegui-los'
                );

            case 4:
                return (
                    'A vida somos nós que a construímos diariamente por isso lute e nunca desista de criar a que sempre sonhou.'
                );

            case 5:
                return (
                    'Sorte é aquela coisa que a gente tem quando começa a correr atrás dos sonhos em vez de sentar e esperar tudo cair do céu.'
                );

            case 6:
                return (
                    'Se hoje está sendo difícil, respire fundo. O ontem passou, hoje vai passar também.'
                );

            case 7:
                return (
                    'Para cada momento em que você pensar em desistir, haverão mais dez pensamentos que te motivam a continuar tentando.'
                );

            case 8:
                return (
                    'Não tente ser uma pessoa de sucesso. Em vez disso, seja uma pessoa de valor.'
                );

            case 9:
                return (
                    'Seja mais, lute mais e torne-se ainda mais capaz para a vida, o mundo e as outras pessoas.'
                );

            case 10:
                return (
                    'Quando você está determinado a fazer algo, a crítica negativa se torna um fator de motivação.'
                );

            case 11:
                return (
                    'Quando você está determinado a fazer algo, a crítica negativa se torna um fator de motivação.'
                );

            case 12:
                return (
                    'A sua vida é importante. A sua tentativa é importante. Cada conquista sua é um grande motivo para celebrar o fato de que você superou e continua vivendo.'
                );

            case 13:
                return (
                    'Dentro de você está o poder para transformar a sua vida e o mundo ao seu redor.'
                );

            case 14:
                return (
                    'Não existe melhor motivação do que amar o trabalho, por isso é tão importante gostar do que se faz.'
                );

            case 15:
                return (
                    'Quando faltar a motivação pense nos seus objetivos e tudo que você já fez para os conseguir.'
                );

            default :
                return (
                    'Quando faltar a motivação pense nos seus objetivos e tudo que você já fez para os conseguir.'
                );
        }
    },

    /**
     * Lista de aplicativos disponíveis para o sistema.
     *
     * @returns {*[]}
     */
    apps() {
        return [
            {
                'name': 'Agendor',
                'label': 'agendor',
                'logo_path': 'images/apps/agendor.png',
                'description': 'Registro de Clientes/Contatos e definição de novos Negócios.',
                'about': 'O Agendor é uma plataforma de aprimoramento em vendas que ajuda milhares de vendedores a alcançarem todo o seu potencial.',
                'category': 'crm',
                'available': true,
            },
            {
                'name': 'Nectar',
                'label': 'nectar',
                'logo_path': 'images/apps/nectar.png',
                'description': 'Receba leads na sua conta Nectar CRM que foram gerados através de pré-atendimentos.',
                'about': 'Somos um CRM para quem quer crescer em alta velocidade e sem perder indicadores!',
                'category': 'crm',
                'available': true,
            },
            {
                'name': 'RD Station',
                'label': 'rdstation',
                'logo_path': 'images/apps/rdstation.png',
                'description': 'A plataforma completa para a sua empresa criar uma verdadeira Máquina de Crescimento',
                'about': 'Do início ao fim do funil de vendas, o RD Station Marketing oferece toda a estrutura necessária para automatizar e gerir suas ações de Marketing Digital',
                'category': 'crm',
                // TODO DESATIVADO TEMPORARIAMENTE 'available': true,
                'available': false,
            },
            {
                'name': 'Pipedrive',
                'label': 'pipedrive',
                'logo_path': 'images/apps/pipedrive.png',
                'description': 'Receba leads na sua conta PipeDrive que foram gerados através de atendimentos.',
                'about': 'Uma plataforma simples desenvolvida para o mínimo de entradas e máximo de resultados.',
                'category': 'crm',
                'available': true,
            },
            {
                'name': 'Exact Sales',
                'label': 'exactsales',
                'logo_path': 'images/apps/exactsales.png',
                'description': 'Inteligência comercial para você vender mais.',
                'about': 'Software e metodologia para atração de clientes, qualificação de leads e aceleração de vendas B2B.',
                'category': 'crm',
                'available': true,
            },
            {
                'name': 'SalesForce',
                'label': 'salesforce',
                'logo_path': 'images/apps/salesforce.png',
                'description': 'Receba leads na sua conta com Salesforce que foram gerados através de atendimentos.',
                'about': 'A Salesforce desenvolve aplicativos de negócios revolucionários, disponibilizados na nuvem e feitos para ajudar você a gerar leads.',
                'category': 'crm',
                'available': false,
            },
            {
                'name': 'Google Agenda',
                'label': 'googleagenda',
                'logo_path': 'images/apps/googleagenda.png',
                'description': 'Defina atividades e eventos que estarão relacionados aos seus leads e atendimentos.',
                'about': 'Google Agenda é um serviço de agenda e calendário on-line oferecido gratuitamente pela empresa Google.',
                'category': 'others',
                'available': false,
            }
        ]
    },

    /**
     * Buscar "Object" do aplicativo instalado.
     *
     * @param appLabel
     *
     * @return mixed|string
     */
    getApp(appLabel) {
        let apps = this.apps()
        for (let a in apps) {
            if ( apps[a].label === appLabel ) {
                return apps[a]
            }
        }
        return null
    },

    /**
     * Verificar se aplicativo já foi instalado.
     *
     * @param company
     * @param appLabel
     *
     * @return boolean
     */
    appIsInstalled(company, appLabel) {
        if (!company.apps || (company.apps.length===0)) return false
        for (let a in company.apps) {
            if (company.apps[a].label === appLabel) {
                return true
            }
        }
        return false
    },

    /**
     * Obter informações do objeto instalado.
     *
     * @param company
     * @param appLabel
     *
     * @return {*}
     */
    getAppInstalled(company, appLabel) {
        if (!company.apps || (company.apps.length===0)) return false
        for (let a in company.apps) {
            if (company.apps[a].label === appLabel) {
                return company.apps[a]
            }
        }
        return null
    },

    /**
     * Verificar se um módulo específico está disponível para esta empresa.
     *
     * @param company
     * @param moduleName
     *
     * @return boolean
     */
    moduleIsAvailable(company, moduleName) {
        if (!company.modules) return false;
        return (( company.modules ) && ( company.modules[moduleName] ) && ( company.modules[moduleName] == 1 ));
    },

    /**
     * Buscar pracas relacionadas a este usuário.
     *
     * @param user
     *
     * @return array
     */
    getMyPraca(user) {
        if (user.metadata && user.metadata.praca) return user.metadata.praca;
        return [];
    },

    /**
     * Formatar 24h componente se departamento esta ativo.
     *
     * @param $department
     *
     * @return string
     */
    at24h_component_from_dep($department) {
        if ( $department.at24h && ( $department.at24h == 'on' )) {
            return '<i class="fa fa-clock-o" aria-hidden="true"></i> 24h'
        }
        return ''
    },

    /**
     * Verificar se departamento possui subdepartamentos.
     *
     * @param department
     *
     * @return bool
     */
    has_sub_departments(department) {
        return ( department.sub_departments && ( department.sub_departments.length > 0 ));
    },

    /**
     * Buscar setores relacionados a este usuário
     *
     * @param user
     * @param company
     *
     * @returns {Array}
     */
    getMyDepartments(user, company) {
        let self = this;
        // setores cadastrados
        const departments = ( company.departments ? company.departments : [] );
        let my_departments = [];

        // formatar conteúdo de sub setores
        const show_sub_departments = function(department = []) {
            if (self.has_sub_departments(department)) {
                for ( let sub in department.sub_departments )
                {
                    show_sub_departments(department.sub_departments[sub]);
                }
            } else if (department.employees) {
                if (( department.employees.length > 0 ) && ( department.employees.indexOf(user._id) > -1 )) {
                    my_departments.push(department.label);
                }
            }
        };

        let department;
        for (let d in departments)
        {
            department = departments[d];
            if (self.has_sub_departments(department)) {
                show_sub_departments(department);
            } else if (department.employees) {
                if (( department.employees.length > 0 ) && ( department.employees.indexOf(user._id) > -1 )) {
                    my_departments.push(department.label);
                }
            }
        }
        return my_departments;
    },

    /**
     * Buscar NOMES de setores relacionados a este usuário
     *
     * @param user
     * @param company
     *
     * @returns {Array}
     */
    getMyDepartmentsNames(user, company) {
        let self = this
        // setores cadastrados
        const departments = ( company.departments ? company.departments : [] );
        let my_departments = [];

        // formatar conteúdo de sub setores
        const show_sub_departments = function(department = [], parents = []) {
            if (self.has_sub_departments(department)) {
                for ( let sub in department.sub_departments )
                {
                    if ( parents.indexOf(department.name) === -1 ) {
                        parents.push(department.name)
                    }
                    show_sub_departments(department.sub_departments[sub], parents);
                }
            } else if (department.employees) {
                if (( department.employees.length > 0 ) && ( department.employees.indexOf(user._id) > -1 )) {
                    let name = ''
                    parents.forEach(function (p) { name += ( p + ' - ' ) })
                    my_departments.push(name + department.name)
                }
            }
        };

        let department;
        for (let d in departments)
        {
            department = departments[d];
            if (self.has_sub_departments(department)) {
                show_sub_departments(department);
            } else if (department.employees) {
                if (( department.employees.length > 0 ) && ( department.employees.indexOf(user._id) > -1 )) {
                    my_departments.push(department.name);
                }
            }
        }
        return my_departments.length > 0 ? my_departments : [ 'Nenhum registrado...' ];
    },

    /**
     * Buscar todos os setores da empresa
     */
    getAllDepartments(company) {
        let self = this
        // setores cadastrados
        let $departments = ( company.departments ? company.departments : [] )
        let $my_departments = []

        // formatar conteúdo de sub setores
        let $show_sub_departments = function($department = []) {
            if (self.has_sub_departments($department)) {
                $department.sub_departments.forEach(function ($sub) {
                    $show_sub_departments($sub)
                })
            } else if ($department.employees) {
                $my_departments.push($department.label)
            }
        }

        $departments.forEach(function ($department) {
            if (self.has_sub_departments($department)) {
                $show_sub_departments($department)
            } else if ($department.employees) {
                $my_departments.push($department.label)
            }
        })
        return $my_departments
    },

    /**
     * Buscar nome do setor
     *
     * @param company
     *
     * @param $departmentLabel
     *
     * @return mixed|string
     */
    getDepartmentName(company, $departmentLabel) {
        let self = this
        // setores cadastrados
        let $departments = ( company.departments ? company.departments : [] )

        // formatar conteúdo de sub setores
        let $show_sub_departments = function($department = [], $parents = []) {
            if (self.has_sub_departments($department)) {
                let $sub = null
                for (let d in $department.sub_departments) {
                    $sub = $department.sub_departments[d]
                    if ( $parents.indexOf($department.name) === -1 ) {
                        $parents.push($department.name)
                    }
                    let $val = $show_sub_departments($sub, $parents);
                    if ($val) {
                        return $val;
                    }
                }
            } else if ($department.employees) {
                if ( $department.label === $departmentLabel ) {
                    let $name = ''
                    for (let p in $parents) {
                        $name += $parents[p] + ' - ';
                    }
                    return $name + $department.name
                }
            }
        };

        let $department = null
        for (let d in $departments ) {
            $department = $departments[d]
            if (self.has_sub_departments($department)) {
                let $val = $show_sub_departments($department, []);
                if ($val) {
                    return $val
                }
            } else if ($department.employees) {
                if ( $department.label === $departmentLabel ) {
                    return $department.name
                }
            }
        }
        return '...';
    },

    /**
     * Exibir informação do Setor, para documentos de relatórios.
     *
     * @param company
     * @param departmentLabel
     * @param handle
     *
     * @returns {*}
     */
    showDepartmentToReports(company, departmentLabel, handle) {
        let self = this
        // lista de setores atuais da empresa
        const _departments = company.departments ? company.departments : [];

        if (departmentLabel) {
            // formatar conteúdo de sub setores
            var show_sub_departments = function(department, parents, handle) {
                if (self.has_sub_departments(department)) {
                    var sub = null
                    for (var ____index in department.sub_departments) {
                        sub = department.sub_departments[____index];
                        if ( parents.indexOf(department) === -1 ) parents.push(department)
                        show_sub_departments(sub, parents, handle)
                    }
                } else if ( department.label == departmentLabel ) {
                    return handle(
                        '<span class="department-tag" style="color:'+ department.tag +'; border: 1px solid '+ department.tag +'; background-color: '+ self.getRGBA(department.tag, 0.25) +'">'+
                            ((function () {
                                var baseName = '';
                                for (var bn in parents) {
                                    if (department.label.search(parents[bn].label) > -1) {
                                        baseName += self.truncate(parents[bn].name, 8) + '&nbsp;';
                                    }
                                }
                                return baseName;
                            })() + self.truncate(department.name, 25))
                        +'</span>'
                    )
                }
            }

            var department = null
            for (var ___index in _departments) {
                department = _departments[___index]
                if (self.has_sub_departments(department)) {
                    show_sub_departments(department, [], function(d) {
                        handle(d)
                    })
                } else if ( department.label == departmentLabel ) {
                    return handle('<span class="department-tag" style="color:'+ department.tag +'; border: 1px solid '+ department.tag +'; background-color: '+ self.getRGBA(department.tag, 0.25) +'">'+ self.truncate(department.name, 25) +'</span>')
                }
            }
        } else {
            return handle('<b style="font-size: 12px;color: #cecece;">...</b>')
        }
    },

    /**
     * Converter tipos de imagens.
     *
     * @param hex
     * @param alpha
     * @returns {string}
     */
    getRGBA(hex, alpha) {
        var c;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+ alpha +')';
        }
        throw new Error('Bad Hex');
    },

    /**
     * Formatar origem do contato via integração do mesmo.
     *
     * @param company
     * @param customer
     *
     * @returns {string}
     */
    formatCustomerOrigin(company, customer) {
        let self = this

        /**
         * Formatar origem do contato via integração do Whatsapp da Empresa.
         *
         * @param customer {*}
         *
         * @return string
         */
        let checkWhatsAppIntegration = function(customer) {
            if (!customer) { return ""; }
            // buscar integrações de whatsapps da empresa
            const companyWhatsApps = company.whatsapps;
            var integrationLabel = '';
            for (var itg in companyWhatsApps) {
                if (!customer.channel_metadata || ( customer.channel_metadata.length == 0 )) {
                    if (itg == 'integration-1') {
                        integrationLabel = companyWhatsApps[itg].label;
                        break;
                    }
                } else {
                    if (itg == customer.channel_metadata.integration) {
                        integrationLabel = companyWhatsApps[itg].label;
                        break;
                    }
                }
            }
            return ' | '+ self.truncate(integrationLabel, 10)
        }

        /**
         * Formatar origem do contato via Widget do Site da Empresa.
         *
         * @param customer {*}
         *
         * @return string
         */
        let checkWidgetIntegration = function(customer) {
            if (!customer) { return ""; }
            // buscar integrações de widgets da empresa
            const companyWidgets = company.widgets;
            var integrationLabel = '';
            for (var itg in companyWidgets) {
                if (!customer.channel_metadata || ( customer.channel_metadata.length == 0 )) {
                    if (itg == 'integration-1') {
                        integrationLabel = companyWidgets[itg].label;
                        break;
                    }
                } else {
                    if (itg == customer.channel_metadata.integration) {
                        integrationLabel = companyWidgets[itg].label;
                        break;
                    }
                }
            }
            return ' | '+ self.truncate(integrationLabel, 10)
        }

        /**
         * Formatar origem do contato via integração do Instagram da Empresa.
         *
         * @param customer {*}
         *
         * @return string
         */
        let checkInstagramIntegration = function(customer) {
            if (!customer) { return ""; }
            // buscar integrações de instagrams da empresa
            const companyInstagrams = company.instagrams;
            var integrationLabel = '';
            for (var itg in companyInstagrams) {
                if (!customer.channel_metadata || ( customer.channel_metadata.length == 0 )) {
                    if (itg == 'integration-1') {
                        integrationLabel = companyInstagrams[itg].label;
                        break;
                    }
                } else {
                    if (itg == customer.channel_metadata.integration) {
                        integrationLabel = companyInstagrams[itg].label;
                        break;
                    }
                }
            }
            return ' | '+ self.truncate(integrationLabel, 10)
        }

        let dataHtml = ''
        if (customer && customer.channel) {
            switch (customer.channel) {
                case 'whatsapp':
                    dataHtml = '<span class="label label-success">WhatsApp'+ checkWhatsAppIntegration(customer) +'</span>';
                    break;
                case 'messenger':
                    dataHtml = '<span class="label label-primary">Messenger</span>';
                    break;
                case 'megasac':
                    dataHtml = '<span class="label label-info" style="background: #2e99ff !important; border-color: #2e99ff !important;">Tallos'+ checkWidgetIntegration(customer) +'</span>';
                    break;
                case 'instagram':
                    dataHtml = '<span class="label label-info" style="background: #7f3bbb !important; border-color: #7f3bbb !important;">Instagram'+ checkInstagramIntegration(customer) +'</span>';
                    break;
                default :
                    dataHtml = '<span class="label label-default" style="opacity: 0.5">Indefinido</span>';
                    break;
            }
        } else {
            dataHtml = '<span class="label label-default" style="opacity: 0.5">Indefinido</span>';
        }
        return dataHtml
    },

    /**
     * Tratar erro ao carregar imagem.
     */
    imgError(event) {
        let image = event.target
        image.onerror = ""
        image.src = `${ configs.api }images/logo-none.png`
    },

    /**
     * Encurtar string de descrições
     *
     * @param desc
     * @param n
     *
     * @returns {string}
     */
    truncate(desc, n)
    {
        return (desc.length > n) ? desc.substr(0, n - 1) + '...' : desc;
    },

    /**
     * Substituição em string
     *
     * @param desc
     * @param search
     * @param replacement
     *
     * @returns {string}
     */
    replaceAll(desc, search, replacement)
    {
        return desc.replace(new RegExp(search, 'g'), replacement);
    },

    /**
     * Detectar e formatar url em string de texto.
     *
     * @param text
     * @returns {*}
     */
    urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
            return '<a class="urlify" href="' + url + '" target="_blank">' + url + '</a>';
        });
    },

    /**
     * Identificar View atual de exibição.
     * @return {string}
     */
    currentView(context) {
        if (context.$store.getters.view.length === 0) {
            return 'home'
        }

        let views = context.$store.getters.view, view = views[views.length -1]
        // definir view a ser exibida
        if (view.view) {
            return view.view
        }
        return view
    },

    /**
     * Verificar se usuário possue uma sessão válida.
     *
     * @return {boolean}
     */
    isLogged(context) {
        return ( !!context.$store.getters.tokenJWT && !!context.$store.getters.user )
    },

    /**
     * Exibir mensagens de alerts. ( Success )
     *
     * @param  msg
     */
    showAlertSuccess(msg) {
        let mainAlertMessage = $('#main-alert-message')
        mainAlertMessage.slideDown()

        $('#content-main-alert-message').html( !msg ? 'Registro atualizado com sucesso.' : msg ).attr('class', 'alert alert-success')

        $("html, body, #content").animate({ scrollTop: 0 }, "slow")

        setTimeout(function () { mainAlertMessage.slideUp() }, 3000)
    },

    /**
     * Exibir mensagens de alerts. ( Danger )
     *
     * @param  msg
     */
    showAlertDanger(msg) {
        let mainAlertMessage = $('#main-alert-message')
        mainAlertMessage.slideDown()

        $('#content-main-alert-message').html( !msg ? 'Erro ao realizar processo.' : msg ).attr('class', 'alert alert-danger')

        $("html, body").animate({ scrollTop: 0 }, "slow")

        setTimeout(function () { mainAlertMessage.slideUp() }, 3000)
    },

    /**
     * Exibir tag para tipo de funcionário.
     * @param role
     * @return {*}
     */
    showEmployeeRole(role) {
        switch (role) {
            case 'admin' :
                return '<span class="label label-primary">Admin</span>';
            case 'seller' :
                return '<span class="label label-default">Vendedor</span>';
            case 'chef' :
                return '<span class="label label-warning">Chef</span>';
            default :
                return '<span style="opacity: 0.5">Nenhum...</span>';
        }
    },

    /**
     * Exibir tag para Status de Preparo do Pedido.
     * @param status
     * @return {*}
     */
    showStatusPreparing(status) {
        switch (status) {
            case 'standing' :
                return '<span class="label label-warning">Aguardando...</span>';
            case 'doing' :
                return '<span class="label label-primary">Produzindo</span>';
            case 'canceled' :
                return '<span class="label label-danger">Cancelado</span>';
            case 'done' :
                return '<span class="label label-success">Feito</span>';
            default :
                return '<span style="opacity: 0.5">Nenhum...</span>';
        }
    },

    /**
     * Exibir tag para Status de Pagamento do Pedido.
     * @param status
     * @return {*}
     */
    showStatusPayment(status) {
        switch (status) {
            case 'standing' :
                return '<span class="label label-warning">Aguardando...</span>';
            case 'payed' :
                return '<span class="label label-success">Pago</span>';
            default :
                return '<span style="opacity: 0.5">Nenhum...</span>';
        }
    },

    /**
     * Default method to Delete registers from listing/tables
     * @param context
     * @param segment
     */
    methodToDelete(context, segment) {
        let helpers = this, self = context
        let body =
            '<div class="row">' +
            '<div class="col-md-12">' +
            '<form id="form-delete">' +
            '<div class="form-group">' +
            '<div class="row">' +
            '<div class="col-md-2"></div>' +
            '<div class="col-md-4">' +
            '<button type="button" class="form-control btn btn-block btn-default btn-cancel-event">Cancelar</button>' +
            '</div>' +
            '<div class="col-md-4">' +
            '<button type="submit" class="form-control btn btn-block btn-special">Deletar</button>' +
            '</div>' +
            '</div>' +
            '</div>' +
            '</form>' +
            '</div>' +
            '</div>'
        // show modal
        let bootboxModal = bootbox.dialog({ message: body })
        // evento ao exibir modal
        bootboxModal.on('shown.bs.modal', function () {

            // escutar btn cancelar evento
            $('.btn-cancel-event').on('click', function () {
                bootbox.hideAll()
            })

            // tratar validação e envio do formulário
            $('#form-delete').on('submit', function (e) {

                e.preventDefault()
                e.isDefaultPrevented()

                $.blockUI(configs.blockUIDefaultStyle)

                helpers.buildRequest(self)
                    .get(helpers.urlAPI(segment))
                    .done(function (result) {
                        // ocultar modals
                        bootbox.hideAll()
                        helpers.showAlertSuccess('O Registro foi Deletado com sucesso.')
                        $.unblockUI()
                        // atualizar listagem da tabela
                        self.table.ajax.reload()
                    })
                    .fail((xhr, status, error) => {
                        bootbox.hideAll()
                        helpers.showAlertDanger()
                        $.unblockUI()
                    })
            })
        })
    },

    formatMoney(value) {
        value = String(parseFloat(value).toFixed(2))
        let v = value.split('.')
        if (v[1] !== undefined) {
            return 'R$ ' + value.replace('.', ',');
        }
        return 'R$ ' + value + ',00';
    },

    formatMoneyToInputs(value) {
        value = String(parseFloat(value).toFixed(2))
        let v = value.split('.')
        if (v[1] !== undefined) {
            return 'R$ ' + value;
        }
        return 'R$ ' + value + '.00';
    },

    // prevent navigation menu items
    preventNavigation(context) {
        // esconder Tooltip em alternancia de paginas
        $('[data-toggle="tooltip"]').tooltip('hide')

        let $SIDEBAR_MENU = $('#sidebar-menu')
        $SIDEBAR_MENU.find('li').removeClass('active active-sm')
        $SIDEBAR_MENU.find('li ul').slideUp()

        // stilo destinado ao Chat
        if ( context.$router.currentRoute.path === '/chat' )
        {
            // $('.x_panel').css({ display: 'block', width: '100%' })
            // $('.x_content').css({ float: 'none' })
            // $('.main-content-blade').css({ margin: '50px 0 0 0', padding: '0px 25px 75px 25px', width: 'auto' })
        }
    },

    // reveter ordem de propriedades do objeto
    reverseObject(object) {
        var newObject = {}, keys = []
        for (let key in object) { keys.push(key) }
        for (let i = keys.length - 1; i >= 0; i--) {
            let value = object[keys[i]];
            newObject[keys[i]]= value;
        }
        return newObject;
    },

    // lista baseada em https://github.com/stopwords-iso/stopwords-pt
    getStopWords() {
        return [

            "a","acerca","adeus","adicionado","agora","ainda","alem","algmas","algo","algumas","alguns","ali","além","ambas","ambos","ano","anos","antes","ao","aonde","aos","apenas","apoio","apontar","apos","após","aquela","aquelas","aquele","aqueles","aqui","aquilo","as","assim","através","atrás","até","aí","baixo","bastante","bem","boa","boas","bom","bons","breve","cada","caminho","catorze","cedo","cento","certamente","certeza","cima","cinco","coisa","com","como","comprido","conhecido","conselho","contra","contudo","corrente","cuja","cujas","cujo","cujos","custa","cá","da","daquela","daquelas","daquele","daqueles","dar","das","de","debaixo","dela","delas","dele","deles","demais","dentro","depois","desde","desligado","dessa","dessas","desse","desses","desta","destas","deste","destes","deve","devem","deverá","dez","dezanove","dezasseis","dezassete","dezoito","dia","diante","direita","dispoe","dispoem","diversa","diversas","diversos","diz","dizem","dizer","do","dois","dos","doze","duas","durante","dá","dão","dúvida","e","ela","elas","ele","eles","em","embora","enquanto","entao","entre","então","era","eram","essa","essas","esse","esses","esta","estado","estamos","estar","estará","estas","estava","estavam","este","esteja","estejam","estejamos","estes","esteve","estive","estivemos","estiver","estivera","estiveram","estiverem","estivermos","estivesse","estivessem","estiveste","estivestes","estivéramos","estivéssemos","estou","está","estás","estávamos","estão","eu","exemplo","falta","fará","favor","faz","fazeis","fazem","fazemos","fazer","fazes","fazia","faço","fez","fim","final","foi","fomos","for","fora","foram","forem","forma","formos","fosse","fossem","foste","fostes","fui","fôramos","fôssemos","geral","grande","grandes","grupo","ha","haja","hajam","hajamos","havemos","havia","hei","hoje","hora","horas","houve","houvemos","houver","houvera","houveram","houverei","houverem","houveremos","houveria","houveriam","houvermos","houverá","houverão","houveríamos","houvesse","houvessem","houvéramos","houvéssemos","há","hão","iniciar","inicio","ir","irá","isso","ista","iste","isto","já","lado","lhe","lhes","ligado","local","logo","longe","lugar","lá","maior","maioria","maiorias","mais","mal","mas","me","mediante","meio","menor","menos","meses","mesma","mesmas","mesmo","mesmos","meu","meus","mil","minha","minhas","momento","muito","muitos","máximo","mês","na","nada","nao","naquela","naquelas","naquele","naqueles","nas","nem","nenhuma","nessa","nessas","nesse","nesses","nesta","nestas","neste","nestes","no","noite","nome","nos","nossa","nossas","nosso","nossos","nova","novas","nove","novo","novos","num","numa","numas","nunca","nuns","não","nível","nós","número","o","obra","obrigada","obrigado","oitava","oitavo","oito","onde","ontem","onze","os","ou","outra","outras","outro","outros","para","parece","parte","partir","paucas","pegar","pela","pelas","pelo","pelos","perante","perto","pessoas","pode","podem","poder","poderá","podia","pois","ponto","pontos","por","porque","porquê","portanto","posição","possivelmente","posso","possível","pouca","pouco","poucos","povo","primeira","primeiras","primeiro","primeiros","promeiro","propios","proprio","própria","próprias","próprio","próprios","próxima","próximas","próximo","próximos","puderam","pôde","põe","põem","quais","qual","qualquer","quando","quanto","quarta","quarto","quatro","que","quem","quer","quereis","querem","queremas","queres","quero","questão","quieto","quinta","quinto","quinze","quáis","quê","relação","sabe","sabem","saber","se","segunda","segundo","sei","seis","seja","sejam","sejamos","sem","sempre","sendo","ser","serei","seremos","seria","seriam","será","serão","seríamos","sete","seu","seus","sexta","sexto","sim","sistema","sob","sobre","sois","somente","somos","sou","sua","suas","são","sétima","sétimo","só","tal","talvez","tambem","também","tanta","tantas","tanto","tarde","te","tem","temos","tempo","tendes","tenha","tenham","tenhamos","tenho","tens","tentar","tentaram","tente","tentei","ter","terceira","terceiro","terei","teremos","teria","teriam","terá","terão","teríamos","teu","teus","teve","tinha","tinham","tipo","tive","tivemos","tiver","tivera","tiveram","tiverem","tivermos","tivesse","tivessem","tiveste","tivestes","tivéramos","tivéssemos","toda","todas","todo","todos","trabalhar","trabalho","treze","três","tu","tua","tuas","tudo","tão","tém","têm","tínhamos","um","uma","umas","uns","usa","usar","vai","vais","valor","veja","vem","vens","ver","verdade","verdadeiro","vez","vezes","viagem","vindo","vinte","você","vocês","vos","vossa","vossas","vosso","vossos","vários","vão","vêm","vós","zero","à","às","área","é","éramos","és","último",

            // não padrões
            'ajuda', 'aquele', 'àquele', 'agora', 'apenas', 'aonde', 'antes', 'aos', 'ao', 'ambos', 'as', 'aqui', 'algum', 'ainda', 'ai', 'aí', 'aquele', 'atendente',
            'bom', 'bem', 'boa',
            'com', 'como', 'contato', 'cima', 'causa', 'cada', 'caso',
            'dia', 'digite', 'de', 'da', 'das',  'do', 'dos',  'duma', 'deles', 'dela', 'dele', 'dentro', 'devo', 'devemos', 'desde', 'desse', 'depois', 'disto',
            'então', 'estes', 'este', 'esta', 'está', 'estar', 'esse', 'esses', 'eles', 'entre', 'ele', 'eu', 'estavam', 'encima', 'em', 'essa', 'estou', 'entendi',
            'fez', 'fazer', 'fora', 'foi', 'falou', 'foi', 'fiz', 'faço',
            'gostaria',
            'há', 'haver', 'houve', 'humano',
            'isso', 'isto',
            'json', 'já', 'ja',
            'lá',
            'mais', 'mas', 'mas', 'mesmo', 'muito', 'muitos',  'meu', 'maioria', 'modo', 'meus', 'minha', 'minhas',
            'noite', 'nao', 'não', 'na', 'no', 'nas', 'nos', 'nunca', 'num', 'nada', 'nenhum', 'nessa', 'nós',
            'oi', 'oiii', 'ola', 'olá', 'outros', 'outro', 'ou', 'os', 'onde', 'ok',
            'poderia', 'por', 'pelo', 'pelas', 'para', 'poderia', 'pegar', 'pegou', 'porém', 'posso', 'pra',
            'que', 'qual', 'quem', 'qualquer', 'quais', 'queria',
            'repetir',
            'ser', 'sendo', 'somente', 'sempre', 'sucesso', 'são', 'sobre', 'seria', 'seu', 'seus', 'sobe', 'se', 'sou', 'só',
            'tarde', 'tudo', 'todos', 'também', 'tem', 'teve', 'tenha', 'tenho', 'ter', 'tal', 'tomar', 'tchau', 'tente',
            'um', 'uma', 'uns', 'umas',
            'vc', 'vcs', 'veio', 'você', 'venha', 'ver',

            // emojis
            '🤖',

            // names
            'Silva', 'Janaína', 'Maria', 'José', 'Mariano', 'Ribeiro',

            'a', 'à', 'á', 'â', 'ã', 'b', 'c', 'ç', 'd', 'e', 'è', 'é', 'ê', 'f', 'g', 'h', 'i', 'ì', 'í', 'j', 'k', 'l', 'm', 'n',
            'o', 'ò', 'ó', 'ô', 'õ', 'p', 'q', 'r', 's', 't', 'u', 'ù', 'ú', 'v', 'w', 'x', 'y', 'z', '$', '1',
            '2', '3', '4', '5', '6', '7', '8', '9', '0', '_',

            // todo correcao temporaria
            '500000'
        ]
    },

    getChatBotKnowledgeParsed(knowledge) {
        var knowledgeList = new Array();

        while(knowledge.length != 0) {
            let originalMessage = knowledge.pop();
            let originalText = originalMessage.text;

            let inResponseTo = new Array();

            // Getting a subset of knowledge.
            let responses = Array.from(knowledge);
            
            for(let child of responses) {
                
                // Join all questions with same answer in a responses array.
                if(originalText === child.text) {
                    let responseChild = { ...child };
                    responseChild.text = responseChild.in_response_to;
                    
                    delete responseChild.in_response_to;

                    inResponseTo.push(responseChild);

                    let removeIndex = knowledge.map(item => item.id).indexOf(child.id);
                    knowledge.splice(removeIndex, 1);
                }
            }

            // Join the origal message in responses array.
            let responseFather = { ...originalMessage };
            responseFather.text = responseFather.in_response_to;
            
            delete responseFather.in_response_to;

            inResponseTo.push(responseFather);

            let message = {
                'text': originalText,
                'in_response_to': inResponseTo
            };

            knowledgeList.push(message);
        }

        return knowledgeList;
    }

}
